// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import {
  CouponAreaDataTestIds,
  CouponAreaId,
  CouponAreaRoutes,
} from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import {
  CouponAreaNavigation,
  CouponAreaNavigationIcon,
} from './CouponAreaNavigation'

const LazyCouponComponent = lazy(() => import('./CouponArea'))

const CouponComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyCouponComponent />
  </SuspenseLoadingWrapper>
)

export const CouponArea = {
  id: CouponAreaId,
  dataTestIds: CouponAreaDataTestIds,
  requiredRight: BoumRight.AREA_COUPON,
  Icon: CouponAreaNavigationIcon,
  NavigationComponent: CouponAreaNavigation,
  route: {
    path: CouponAreaRoutes.route,
    component: CouponComponent,
  },
}
